import { Fragment } from "react/jsx-runtime";
import { Button, Col, Row, Typography } from "antd";
import { COUPLE } from "../../../constants/AppConstants";

import "./CoupleSection.css";

const { Title } = Typography;

export default function CoupleSection() {
  return (
    <Fragment>
      <Row className="mb-80">
        <Col className="couple-container couple-container-one" md={12} sm={24}>
          <Title className="couple-title title-one" level={3} strong>
            {COUPLE.TITLE_ONE}
          </Title>
          <Button href="/boletos" className="couple-button-one">
            {COUPLE.BUTTON_ONE}
          </Button>
        </Col>
        <Col className="couple-container couple-container-two" md={12} sm={24}>
          <Title className="couple-title title-two" level={3} strong>
            {COUPLE.TITLE_TWO}
          </Title>
          <Button href="/#preguntas" className="couple-button-two">
            {COUPLE.BUTTON_TWO}
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
}
